import { Builder } from '@builder.io/react'
import dynamic from 'next/dynamic'

Builder.registerComponent(
    dynamic(() =>
        import('./OrderStatus').then((res) => res.OrderStatus as any)
    ),
    { name: 'Order Status' }
)
